import React, { Fragment, useEffect, useMemo, useState } from 'react';

import { tableConfig } from '../../../constants/tables.js';
import { getAdditionalFilter } from '../../../utils/filters.js';
import { ActionTypes } from '../../Administration/utils.js';
import CustomModal from '../../Reusable/Modal/CustomModal.js';
import ModalForPasswordChange from '../../User/Password/ModalForPasswordChange.js';
import AgGrid from '../AgGrid.js';
import { getProcessType, isActionProcess } from '../action-utils.js';
import { getSettingsAndDataForForm } from '../utils.js';

const DataProcessModal = (props) => {
  const { show, hideModal, action, title, gridRef, selectedRow, tableName } =
    props || {};

  const tableConfigurations = Object.keys(tableConfig).reduce((acc, key) => {
  acc[tableConfig[key].name] = tableConfig[key];
  return acc;
}, {});

const [config, setConfig] = useState({});

useEffect(() => {
  if (tableName && tableConfigurations[tableName]) {
    setConfig(tableConfigurations[tableName]);
  }
}, [tableName, tableConfigurations]);

const getAdditionalTitleInfo = useMemo(() => {
  return selectedRow && config?.checkName?.(selectedRow);
}, [config, selectedRow]);

  return (
    <Fragment>
      {show && isActionProcess(action) && (
        <CustomModal
          show={show}
          hideModal={hideModal}
          wideModal={true}
          additionalTitleInfo={getAdditionalTitleInfo}
          title={title}
          isView={false}
          hideSaveButton
        >
          <AgGrid
            {...getSettingsAndDataForForm(getProcessType(action, config).type)}
            type={getProcessType(action, config).type}
            hideButtons={false}
            inForm={true}
            initialSearch={false}
            additionalFilterCriteria={getAdditionalFilter(
              config.processDataFilterKey,
              selectedRow?.id
            )}
            gridRef={gridRef}
            showAttributeView={true}
          />
        </CustomModal>
      )}
      {show && action === ActionTypes.SHOW_CHILDREN && (
        <CustomModal
          show={show && action === ActionTypes.SHOW_CHILDREN}
          hideModal={hideModal}
          hideSaveButton
          title={title}
          additionalTitleInfo={getAdditionalTitleInfo}
          isView={false}
          wideModal={false}
        >
          <AgGrid
            {...getSettingsAndDataForForm(config.childrenType)}
            type={config.childrenType}
            hideButtons={false}
            inForm={true}
            initialSearch={false}
            additionalFilterCriteria={getAdditionalFilter(
              config?.showChildrenFilterKey,
              selectedRow?.id
            )}
            gridRef={gridRef}
            isView={false}
            showAttributeView={true}
            hideActionColumn={true}
          />
        </CustomModal>
      )}
      {show && action === ActionTypes.PASSWORD_CHANGE && (
        <ModalForPasswordChange
          show={show && action === ActionTypes.PASSWORD_CHANGE}
          hideModal={hideModal}
          title={title}
          additionalTitleInfo={getAdditionalTitleInfo}
          // submitHandler={onPasswordChangeSubmitHandler} //TODO srediti
          updatePasswordSignal={true}
        />
      )}
    </Fragment>
  );
};
export default DataProcessModal;
